import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';

import './FilersCases.less';


class FilersCases extends Component {
  getFilersTableBody = (data) => {
    if (data.length === 0) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }

    if (data.empty) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {data.empty}
          </div>
        </div>
      );
    }

    const rows = data.map((item, key) => (
      <tr key={key}>
        <td>{ item.name || '' }</td>
        <td>{ item.type || '' }</td>
        <td>{ item.date_added || '' }</td>
        <td>{ item.date_terminated || '' }</td>
      </tr>
    ));
    return (
      <div>
        <FilterTable
          premiumSearch={{ uuid: this.props.case_uuid, query: this.props.type }}>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>Name</span></th>
                <th><span>Type</span></th>
                <th><span>Date Added</span></th>
                <th><span>Date Terminated</span></th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </table>
        </FilterTable>
      </div>
    );
  };

  render() {
    const { dataReady, error, filers } = this.props;
    if (!dataReady) return <LoadingBar />;
    if (!_.isEmpty(error)) return <AlertError errors={error} />;
    const tableData = filers || [];
    // optional add sort by data added, commented out because in live its not sorted
    // const sortedTableData = _.sortBy(tableData, filer => new Date(filer.date_added)).reverse();
    return (
      <div className={this.props.type}>
        {this.getFilersTableBody(tableData)}
        <UpdateFromPacer
          pacerUpdateHandler={this.props.purchaseData}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated} />
      </div>
    );
  }
}

FilersCases.defaultProps = {
  error: null,
  receipt: null,
  type: 'filers',
};

FilersCases.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  filers: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
};

export default FilersCases;



// WEBPACK FOOTER //
// ./src/components/case/filers/FilersCases.js